import { GetOIDCHub } from "../assets/auth/serviceConfig";

export const Callback:React.FC = () => {
    GetOIDCHub().callback();
    return (
        <div>
            Loading....
        </div>
    )
}